export default "__VITE_ASSET__BbVkrpPQ__"